import "./home.css"
import Leftbar from "../../components/leftbar/Leftbar"
import Rightbar from "../../components/rightbar/Rightbar"
import Topbar from "../../components/topbar/Topbar"
import Middle from "../middle/Middle"
import { io } from "socket.io-client"
import { useEffect, useRef, useState } from "react"
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import axios from "axios"
import { UnfoldLessRounded } from "@mui/icons-material"

export default function Home({ socketio, connectionState, selectedMission, setSelectedMission }) {
  const [isMissionDragging, setMissionDragging] = useState(false);
  const [missions, setMissions] = useState([])
  //const url = require("assets/sounds/nada-6-326005.mp3");
  const Sound = new Audio("../assets/sounds/nada-6-326005.mp3");

  const playSound = () => {
    Sound.play();
  }
  const fetchMissions = async () => {
    try {
      const res = await axios.get("/api/missions/");
      setMissions(res.data.sort((p1, p2) => {
        return new Date(p2.createdAt) - new Date(p1.createdAt)
      }))
    } catch (err) {
      console.log(err)
    }
  }

  const newMission = () => {
    try {
      playSound();
    } catch (err) {
      console.log(err);
    }
    fetchMissions();
  }

  useEffect(() => {
    Sound.load();
    fetchMissions();
    socketio.on("newMission", newMission);
    socketio.on("ChangedMissions", fetchMissions);
  }, [])

  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <Topbar connectionState={connectionState} selectedMission={selectedMission} isMissionDragging={isMissionDragging} />
        <div className="mainContainer">
          <Leftbar
            socketio={socketio}
            selectedMission={selectedMission}
            setSelectedMission={setSelectedMission}
            isMissionDragging={isMissionDragging}
            setMissionDragging={setMissionDragging}
            missions={missions}
            setmissions={setMissions} />
          <Middle
            selectedMission={selectedMission}
            setSelectedMission={setSelectedMission}
            missions={missions}
            setmissions={setMissions} />
          <Rightbar />
        </div>
      </DndProvider>
    </>
  )
}
